import { submitJob } from "./jobClient.js";
import { pollJob } from "./jobPoller.js";
import { ML_API, saveJob } from "./storage.js";

export async function ml_queue_api(
  url,
  payload,
  successCallback,
  errorCallback = (err) => console.error("❌ Error:", err),
  apiBase = ML_API,
) {
  const job = await submitJob(url, payload);

  saveJob(job);

  pollJob({
    jobId: job.job_id,
    statusUrl: `${apiBase}/job_result/${job.job_id}`,
    interval: 4000,
    timeout: 7 * 60 * 1000,
    onUpdate: () => {},
    onComplete: (result) => {
      successCallback(result);
    },
    onError: (err) => {
      errorCallback(err);
    },
  });
}
